import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import LoginButton from './LoginButton.jsx';

const UserProfile = ({ onSettingsClick }) => {
   const { user, isAuthenticated, logout } = useAuth0();
   const [imageError, setImageError] = React.useState(false);

   const getInitials = (name) => {
      if (!name) return '?';
      const names = name.split(' ');
      if (names.length >= 2) {
         return (names[0][0] + names[names.length - 1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
   };

   return (
      isAuthenticated ?
         (
            <React.Fragment>
               <li className="nav-item nav-icon">
               <div className="btn-group">
                  <button 
                     type="button" 
                     className="btn btn-sm p-0" 
                     data-bs-toggle="dropdown" 
                     aria-expanded="false"
                     style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        border: '2px solid #1E70E0',
                        background: 'transparent',
                        padding: '0 !important',
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxSizing: 'border-box'
                     }}
                  >
                     {!imageError && user.picture ? (
                        <img 
                           src={user.picture} 
                           alt={user.name}
                           onError={() => setImageError(true)}
                           style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: '50%',
                              display: 'block',
                              margin: '0',
                              padding: '0',
                              boxSizing: 'border-box'
                           }}
                        />
                     ) : (
                        <span style={{
                           width: '36px',
                           height: '36px',
                           borderRadius: '50%',
                           background: 'linear-gradient(135deg, #1E70E0 0%, #1557b0 100%)',
                           color: 'white',
                           display: 'flex',
                           alignItems: 'center',
                           justifyContent: 'center',
                           fontSize: '14px',
                           fontWeight: '600'
                        }}>
                           {getInitials(user.name)}
                        </span>
                     )}
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end" style={{
                     position: 'absolute',
                     zIndex: 10000,
                     minWidth: '250px',
                     boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                     border: '1px solid rgba(0,0,0,0.1)',
                     borderRadius: '8px',
                     marginTop: '8px'
                  }}>
                     <li className="px-3 py-2 border-bottom">
                        <div className="fw-bold">{user.name}</div>
                        <div className="text-muted small">{user.email}</div>
                     </li>
                     <li>
                        <a 
                           className="dropdown-item" 
                           href="#"
                           onClick={(e) => {
                              e.preventDefault();
                              onSettingsClick();
                           }}
                        >
                           <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="me-2">
                              <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
                           </svg>
                           Settings
                        </a>
                     </li>
                     <li><hr className="dropdown-divider" /></li>
                     <li>
                        <a 
                           className="dropdown-item text-danger" 
                           href="#"
                           onClick={(e) => {
                              e.preventDefault();
                              logout({ logoutParams: { returnTo: window.location.origin } });
                           }}
                        >
                           <i className="fa fa-sign-out me-2"></i>
                           Logout
                        </a>
                     </li>
                  </ul>
                  </div>

               </li>
            </React.Fragment>
         ) : <LoginButton />
   );
};

export default UserProfile;